import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.scss';
import store, { persistor } from './store';
import { bootstrapWebView, loadPartnerSettings, redirectToBooking, WEBVIEW_BYPASS_PHONE_KEY } from './utilities/webview';

const { partner, token, phone } = bootstrapWebView();

// Partner already resolved a Swift247 user token (e.g. Vikki called
// POST /v1/partner/user-token successfully) — skip rendering the login SPA
// entirely and forward straight into booking. Still need partner settings
// (theme + partner_name) fetched/cached first, so booking picks up the
// correct theme and the redirect carries the resolved `partner=` param.
if (token) {
  loadPartnerSettings(partner).then(() => redirectToBooking(token));
} else {
  if (phone) {
    // No account yet — stash the phone so ValidatePhoneNumber can auto-submit it
    // on mount instead of asking the user to type it again.
    sessionStorage.setItem(WEBVIEW_BYPASS_PHONE_KEY, phone);
  }

  const container = document.getElementById('root');
  // @ts-ignore
  const root = createRoot(container);

  const renderApp = () => {
    root.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {/* <React.StrictMode> */}
          <App />
          {/* </React.StrictMode> */}
        </PersistGate>
      </Provider>,
    );
  };

  loadPartnerSettings(partner).then(renderApp);
}
